import React, { useState, useEffect } from 'react'
import { Card, Col, Icon, Row, Skeleton, Tooltip } from 'antd'

import './index.less'
import _ from 'lodash'
import moment from 'moment'
import { getSMSStat } from '../../../api/different'

const SMSStat = () => {
  const coefficient = 2.5
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const params = {
      date_begin: moment().add(-1, 'M').format('DD.MM.YYYY'),
      date_end: moment().format('DD.MM.YYYY'),
    }

    getSMSStat(params)
      .then((res) => {
        const tmpData = []
        res.result.map((item, key) => {
          tmpData[key] = {
            d_month: item[0].d_month,
            n_count_sms: item[1].n_count_sms,
            n_count_service_sms: item[2].n_count_service_sms,
            n_count_billing: item[3].n_count_billing,
          }
        })
        setData(tmpData)
        setLoading(false)
      })
      .catch((res) => {
        console.log(res)
        console.log('Error')
        setLoading(false)
      })
  }, [])

  return (
    <div>
      {!loading ?
        <Row type='flex' gutter={16}>{data.map((item, key) =>
        (<Col key={key} >
          <Card
            className='card-sms'
            title={`За ${moment(item.d_month, 'YYYY-MM-DD').format('MMMM')} месяц ${moment(item.d_month, 'YYYY-MM-DD').format('YYYY')} года`}
            actions={[
              <Tooltip title='Общее количество отправленных сообщений'>Отпр.: {Number(item.n_count_sms) + Number(item.n_count_service_sms)}</Tooltip>,
              <Tooltip title='Общее количество сообщений по биллингу'>Биллинг: {Number(item.n_count_billing)}</Tooltip>,
            ]}
          >
            <p>Информационных сообщений: {item.n_count_sms}</p>
            <p>Шаблонных сообщений: {item.n_count_service_sms}</p>
            <p>Сообщений по биллингу: {Number(item.n_count_billing)}</p>
          </Card>
         </Col>))}
        </Row>
      :
        <Skeleton active />}
    </div>
  )
}

export default SMSStat



// WEBPACK FOOTER //
// src/containers/Dashboard/SMSStat/index.jsx